import { BASE_URL } from '../constants';
import { errorHandling, errorHandler } from '../utils/errorHandling';
import { getItem } from '../utils/localStore';

class userActivityApi {

    static doUserActivity(data) {
        const TOKEN = getItem('auth_token');
        let isError = false;

        let userActivityData={
            ext_id: data.ext_id,
            screen_id: data.screen_id,
            source: data.source,
        }

        try{
            const ajaxRequestHeaders = new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Authorization': TOKEN
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body: JSON.stringify(userActivityData)
            }
            return fetch(BASE_URL + '/user_activity', body).then(response => {
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default userActivityApi;